<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch1.jpg" width="4%"/></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%;"><a id="pg-1">“This town stinks!”</a></p><a id="pg-1">
<p class="para" style="text-indent: 5%;">It’s Friday afternoon — the end of your first week at your new school. Your family just moved to this town last month. And so far no one at school has even tried to be your friend.</p>
<p class="para" style="text-indent: 5%;">Day after day, you sit in class waiting for someone to talk to you. Waiting and staring at all the strange faces around you. How can you possibly go through the year without any friends? you wonder. You’re cool. You know you are. You had tons of friends at your old school.</p>
<p class="para" style="text-indent: 5%;">You trudge home slowly. All you have to look forward to is a boring weekend of watching TV with your parents and your bratty little brother. Then something hits the back of your jacket.</p>
<p class="para" style="text-indent: 5%;">You whirl around. A pebble drops onto the ground. You glance up — and notice a brown-haired boy about your own age.</p>
<p class="para" style="text-indent: 5%;">“Hi!” he calls out. “I’m Nick!”</p>
<p class="para" style="text-indent: 5%;">“Hi,” you reply and introduce yourself.</p>
<p class="para" style="text-indent: 5%;">“We’re in the same class at school,” Nick says.</p>
<p class="para" style="text-indent: 5%;">That’s funny, you think. You don’t remember seeing him there. But you smile anyway. You’re so happy someone is finally talking to you.</p>
<p class="para" style="text-indent: 5%;">“I live there,” Nick tells you. He points to a two-story green house on the next block. You gaze back at him, shocked.</p>
<p class="para" style="text-indent: 5%;">“But you can’t live there!” you exclaim. “There’s no way!”</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-1"><em class="italic">Go on to </em></a><a href="#/e9780545841030_ch002"><em class="italic">PAGE 2</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841030_ch001.vue?580655af